"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnprocessableEntityException = exports.PaymentRequiredException = exports.GenericRetryableException = exports.DeactivatedException = exports.NotImplementedException = exports.ServiceException = exports.RateLimitException = exports.ForbiddenException = exports.GoneException = exports.ConflictException = exports.NotFoundException = exports.BadRequestException = exports.InternalException = exports.RemoteAuthException = exports.OurAuthException = void 0;
class APIException extends Error {
    constructor(message, { extra = undefined, userMessage = undefined, originalError = undefined, errorCode = undefined, remoteService = false, retryAfter = undefined, shouldLog, } = {} // so that options can be omitted at all
    ) {
        super();
        this.statusCode = 500; // default error code
        this.remoteService = false;
        this.shouldLog = true;
        this.name = "APIException";
        this.message = message;
        this.stack = new Error().stack;
        this.extra = extra;
        this.userMessage = userMessage;
        this.originalError = originalError;
        this.errorCode = errorCode;
        this.remoteService = remoteService;
        this.shouldLog = shouldLog;
        if (retryAfter) {
            this.retryAfter = retryAfter;
        }
    }
}
/* istanbul ignore next */
class BadRequestException extends APIException {
    constructor() {
        super(...arguments);
        this.statusCode = 400;
        this.name = "BadRequestException";
    }
}
exports.BadRequestException = BadRequestException;
/* istanbul ignore next */
class OurAuthException extends APIException {
    constructor() {
        super(...arguments);
        this.statusCode = 401;
        this.name = "OurAuthException";
    }
}
exports.OurAuthException = OurAuthException;
/* istanbul ignore next */
class RemoteAuthException extends APIException {
    constructor() {
        super(...arguments);
        this.statusCode = 401;
        this.name = "RemoteAuthException";
        this.remoteService = true;
    }
}
exports.RemoteAuthException = RemoteAuthException;
/* istanbul ignore next */
class PaymentRequiredException extends APIException {
    constructor() {
        super(...arguments);
        this.statusCode = 402;
        this.name = "PaymentRequired";
    }
}
exports.PaymentRequiredException = PaymentRequiredException;
/* istanbul ignore next */
class ForbiddenException extends APIException {
    constructor() {
        super(...arguments);
        this.statusCode = 403;
        this.name = "ForbiddenException";
    }
}
exports.ForbiddenException = ForbiddenException;
/* istanbul ignore next */
class NotFoundException extends APIException {
    constructor() {
        super(...arguments);
        this.statusCode = 404;
        this.name = "NotFoundException";
    }
}
exports.NotFoundException = NotFoundException;
/* istanbul ignore next */
class ConflictException extends APIException {
    constructor() {
        super(...arguments);
        this.statusCode = 409;
        this.name = "ConflictException";
    }
}
exports.ConflictException = ConflictException;
/* istanbul ignore next */
class GoneException extends APIException {
    constructor() {
        super(...arguments);
        this.statusCode = 410;
        this.name = "GoneException";
    }
}
exports.GoneException = GoneException;
/* istanbul ignore next */
class RateLimitException extends APIException {
    constructor() {
        super(...arguments);
        this.statusCode = 429;
        this.name = "RateLimitException";
        this.remoteService = true;
    }
}
exports.RateLimitException = RateLimitException;
/* istanbul ignore next */
class InternalException extends APIException {
    constructor() {
        super(...arguments);
        this.statusCode = 500;
        this.name = "InternalException";
    }
}
exports.InternalException = InternalException;
/* istanbul ignore next */
class ServiceException extends APIException {
    constructor() {
        super(...arguments);
        this.statusCode = 503;
        this.name = "ServiceException";
        this.remoteService = true;
    }
}
exports.ServiceException = ServiceException;
/* istanbul ignore next */
class NotImplementedException extends APIException {
    constructor() {
        super(...arguments);
        this.statusCode = 500;
        this.name = "NotImplementedException";
    }
}
exports.NotImplementedException = NotImplementedException;
/* istanbul ignore next */
class DeactivatedException extends APIException {
    constructor() {
        super(...arguments);
        this.name = "DeactivatedException";
        this.statusCode = 403;
    }
}
exports.DeactivatedException = DeactivatedException;
class UnprocessableEntityException extends APIException {
    constructor() {
        super(...arguments);
        this.name = "UnprocessableEntityException";
        // Unprocessable entity exceptions are not logged by default
        this.shouldLog = false;
        this.statusCode = 422;
    }
}
exports.UnprocessableEntityException = UnprocessableEntityException;
/* istanbul ignore next */
class GenericRetryableException extends APIException {
    constructor() {
        super(...arguments);
        this.name = "GenericRetryableException";
        this.statusCode = 503;
    }
}
exports.GenericRetryableException = GenericRetryableException;
//# sourceMappingURL=api_exceptions.js.map